import React from 'react';
import { useParams } from 'react-router-dom';
import { SelectRowInspector } from '../../molecules/select-row-inspector';
import { RowLoader } from '../component-loader';

const AuthorsPage = () => {
  const { publisherId = '' } = useParams();

  return (
    <>
      <RowLoader />
      <SelectRowInspector publisherId={publisherId} />
    </>
  );
};

export default AuthorsPage;
